var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm.keepAlive)?_c('div',[_c('keep-alive',[_c('router-view')],1)],1):_vm._e(),(!_vm.keepAlive)?_c('div',[_c('router-view')],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }